/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Keynote56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M44 32a8 8 0 110 16 8 8 0 010-16zM8 24c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
            <g fillRule="nonzero">
                <path
                    fill={vars.bdlBoxBlue}
                    d="M49 6a3 3 0 110 6v22a3.997 3.997 0 01-2.029 3.481 4.002 4.002 0 01-3.768 3.514L43 41H28.5v3l-.002.03A4.003 4.003 0 0132 48c0 2.21-1.79 4-4 4s-4-1.79-4-4a4.003 4.003 0 013.503-3.97L27.5 44v-3H13a4 4 0 01-3.971-3.52 3.997 3.997 0 01-2.023-3.258L7 34V12a3 3 0 110-6h42zM28 46a2 2 0 10-.001 3.999A2 2 0 0028 46zm16.731-8H11.268l.054.089c.301.463.789.793 1.356.885l.173.02L13 39h30c.644 0 1.217-.305 1.583-.778l.095-.133.053-.089zM47 12H9v22a2 2 0 001.697 1.977l.154.018L11 36h34a2.001 2.001 0 001.995-1.85L47 34V12zm2-4H7a1 1 0 00-.117 1.993L7 10h42a1 1 0 00.117-1.993L49 8z"
                />
                <path
                    fill={vars.bdlBoxBlue10}
                    d="M44.731 38l-.053.089A2 2 0 0143 39H13l-.15-.005a2.002 2.002 0 01-1.528-.906L11.268 38h33.463zM49 8H7a1 1 0 00-.117 1.993L7 10h42a1 1 0 00.117-1.993L49 8z"
                />
                <path fill={vars.white} d="M9 12h38v22a2 2 0 01-2 2H11l-.15-.005A2.001 2.001 0 019 34V12z" />
                <path
                    fill={vars.bdlBoxBlue}
                    d="M28 18a6 6 0 110 12 6 6 0 010-12zm0 1a5 5 0 10.001 10.001A5 5 0 0028 19z"
                />
                <path fill={vars.bdlBoxBlue10} d="M28 19a5 5 0 10.001 10.001A5 5 0 0028 19z" />
                <path
                    fill={vars.bdlBoxBlue}
                    d="M33 18c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 1a3 3 0 100 6 3 3 0 000-6z"
                />
                <path fill={vars.white} d="M33 19a3 3 0 100 6 3 3 0 000-6z" />
            </g>
            <circle cx={43} cy={32} r={1} fill={vars.bdlBoxBlue} />
        </g>
    </AccessibleSVG>
);

export default Keynote56;
